'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // Sets the vertical or horizontal position of an element.


var setPosition = function setPosition(position) {
  var obj = {};
  obj[position] = '0';
  return obj;
};

var setContentTransformValue = function setContentTransformValue(position) {
  if (position === 'left') {
    return 'translateX(-100%)';
  } else if (position === 'right') {
    return 'translateX(100%)';
  } else if (position === 'top') {
    return 'translateY(-100%)';
  } else {
    return 'translateY(100%)';
  }
};

var setPushTransformValue = function setPushTransformValue(width, height, position) {
  if (position === 'left') {
    return 'translateX(' + width + ')';
  } else if (position === 'right') {
    return 'translateX(-' + width + ')';
  } else if (position === 'top') {
    return 'translateY(' + height + ')';
  } else {
    return 'translateY(-' + height + ')';
  }
}; // Checks whether an element has a className.


var hasClassName = exports.hasClassName = function hasClassName(element) {
  return element && element.classList.length > 0;
};

var shouldShowContent = exports.shouldShowContent = function shouldShowContent(content, isOpen) {
  if (content) {
    content.style.visibility = isOpen ? 'visible' : 'hidden';
  }
};

var createStyles = exports.createStyles = function createStyles(defaultStyles, extraStyles, isOpen, width, height, position, customStyles) {
  var positionProperty = setPosition(position);
  return {
    overlay: _extends({}, defaultStyles.overlay, extraStyles.overlay, {
      width: isOpen ? '100%' : ''
    }, customStyles.overlay),
    content: _extends({}, defaultStyles.content, extraStyles.content, positionProperty, {
      width: width,
      height: height,
      transform: isOpen ? '' : setContentTransformValue(position)
    }, customStyles.content, {
      // !important
      // Off-Canvas element should be able to receive focus immediately.
      // https://allyjs.io/tutorials/focusing-in-animated-ui.html#remedy-2-caveat
      transitionProperty: isOpen ? 'transform' : ''
    })
  };
};

var createPushStyles = exports.createPushStyles = function createPushStyles(extraStyles, isOpen, width, height, position) {
  var styles = _extends({}, extraStyles, {
    transform: isOpen ? setPushTransformValue(width, height, position) : ''
  });

  return function (element) {
    if (element) {
      // Apply the push styles
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.keys(styles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var property = _step.value;
          element.style[property] = styles[property];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  };
};

var applyInitialPushStyles = exports.applyInitialPushStyles = function applyInitialPushStyles(element, width, height, position) {
  if (element) {
    element.style.transform = setPushTransformValue(width, height, position);
  }
}; // Shows/hides the horizontal scrollbar.


var shouldHideHorizontalScrollbar = exports.shouldHideHorizontalScrollbar = function shouldHideHorizontalScrollbar(isOpen) {
  var body = document.querySelector('body');
  body.style.overflowX = isOpen ? 'hidden' : '';
};